import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import ViewModal from "../../Components/Applications/PreviewModel";
import CompleteModal from "../../Components/Applications/CompleteModel";
import IsDocsModel from "../../Components/Applications/IsDocsModel";

import {
  gCouncilList,
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
} from "../../Config";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  SmallBtn,
  PreviewBtn,
  PrevBtn,
  OtherBtn,
  SaveBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import Select from "react-select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { Update_User } from "../../Redux/actions";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";
import { FormControlUnstyledContext } from "@mui/base";

const RegistrationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [openViewModel, setOpenViewModel] = useState(false);
  const [completeViewModel, setCompleteViewModel] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAppId, setAppId] = useState(null);
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  const [submitDocsModel, setSubmitDocsModel] = useState(false);

  const [isAffiliated, setIsAffiliated] = useState({ yes: false, no: false });
  const [isRestricted, setIsRestricted] = useState({ yes: false, no: false });
  const [isRegistered, setIsRegistered] = useState({ yes: false, no: false });
  // const [isRegistered, setIsRegistered] = useState(false);
  const [isInterested, setIsInterested] = useState({ yes: false, no: false });
  const [typeOfAssocLabel, setTypeOfAssocLabel] = useState("");
  const [typeOfAssoc, setTypeOfAssoc] = useState("");

  const [game, setGame] = useState("");
  const [games, setGames] = useState([]);
  const [gameLabel, setGameLabel] = useState("");

  const [typeOfRegLabel, setTypeOfRegLabel] = useState("");
  const [typeOfReg, setTypeOfReg] = useState("");

  const [regionLabel, setRegionLabel] = useState("");
  const [region, setRegion] = useState("");

  const [districtLabel, setDistrictLabel] = useState("");
  const [district, setDistrict] = useState("");

  const [councilLabel, setCouncilLabel] = useState("");
  const [council, setCouncil] = useState("");

  const [isSubmitable, setIsSubmitable] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [chairmanSign, setChairmanSignature] = useState("");
  const [secretarySign, setSecretarySignature] = useState("");
  //console.log(allDistrictsList);

  const [councilList, setCouncilList] = useState([]);
  const [districtsList, setDistricts] = useState([]);
  const [assocList, setAssociation] = useState([]);

  const { customerId, bookingId } = useParams();

  const user = useSelector((state) => state?.UserReducer?.user);

  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

/**************** Dynamic Districts & Councils ********************/

// if (Config.rdcDataFromBackend == 'Yes')
// {
//     const gDynamicCouncils = useSelector(
//       (state) => state?.CouncilsDataReducer?.councils
//     );
    
//     const gDynamicDistricts = useSelector(
//       (state) => state?.DistrictsDataReducer?.districts
//     );
//     const gDynamicRegions = useSelector(
//       (state) => state?.RegionsDataReducer?.regions
//     );

//     const SetDynamicDistricts = (value) => {
//       //console.log("SetDynamicDistricts");
//       setCouncil("");
//       setCouncilLabel("");
//       setDistrict("");
//       setDistrictLabel("");
//       var districtOptions = gDynamicDistricts
//       ?.filter((item) => item.region === value)
//       .map((item) => ({
//         name: item.name,
//         id: item.id,
//       }));
//       setDistricts(districtOptions);
//     };

//     const SetDynamicCouncil = (value) => {
//       setCouncil("");
//       setCouncilLabel("");
//       var councilOptions = gDynamicCouncils
//       ?.filter((item) => item.district === value)
//       .map((item) => ({
//         name: item.name,
//         id: item.id,
//       }));
//       setCouncilList(councilOptions);
//     };

//     const RegionList = gDynamicRegions.map((item) => ({
//       value: item.id,
//       label: item.name,
//     }));
// }

/**************** End Dynamic Districts & Councils ********************/

/**************** Static Districts & Councils ********************/

//if (Config.rdcDataFromBackend == 'No')
//{
    const RegionList = gRegionsList.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    
    const SetDynamicDistricts = (value) => {
      setCouncil("");
      setCouncilLabel("");
      setDistrict("");
      setDistrictLabel("");
      setDistricts(gDistrictsList[value]);
      //console.log(gDistrictsList[value]);
      //console.log(districtsList);
    };

    const SetDynamicCouncil = (value) => {
      setCouncil("");
      setCouncilLabel("");
      // console.log(gCouncilList[region]);
      //console.log(gCouncilList[region][value]);
      setCouncilList(gCouncilList[region][value]);
    };
//}
/**************** End Static Districts & Councils ********************/

  const RegistrationList = gTypeOfRegistration.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const AssociationList = assocList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const GameList = gTypeOfGame.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  
  //console.log(user);
  //console.log(gTypeOfGame);

  const [customerDetails, setCustomerDetails] = useState({});
  const [isPublished, setIsPublished] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);
  const [isReportsent, setIsReportSent] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [reportId, setReportId] = useState("");

  const [isAddDeviceModelOpen, setIsAddDeviceModelOpen] = useState(false);
  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);
  const [openCreateBookingModel, setOpenCreateBookingModel] = useState(false);

  useEffect(() => {
    if (!previewOpenModel) setIsReportSent(false);
  }, [previewOpenModel]);

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);

  // -------------  Initial Data -------------
  // const fetchFunction = async () =>
  //   await axios.get(
  //     `${Config.nodeApiUrl}/getSenderIdContactGroups/sms`,
  //     Config.AxiosConfig
  //   );

  // const {
  //   data,
  //   error,
  //   isLoading: InitialLoading,
  // } = useQuery(`getSenderIdContactGroups`, fetchFunction);

  // -------------   Run Campaign  -------------
  const postFunction = async (values) => {
    if (openViewModel == false) {
      return await axios.post(`${Config.apiUrl}/registerassocnew`, values, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    }
  };

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      setAppId(res?.data?.appid);
      setSubmitDocsModel(true);
      // navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoading, mutate: assocRegisterMutate } = useMutation(
    postFunction,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  // -------------   Save Application  -------------
  const postFunctionSave = async (values) => {
    if (openViewModel == false) {
      return await axios.post(`${Config.apiUrl}/registerassocsave`, values, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    }
  };

  const onSuccessSave = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onErrorSave = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingSave, mutate: assocRegisterMutateSave } =
    useMutation(postFunctionSave, {
      onSuccess: onSuccessSave,
      onError: onErrorSave,
    });

  const InitialValue = {
    assocName: "",
    typeOfReg: "",
    typeOfRegLabel: "",
    typeOfAssoc: "",
    typeOfAssocLabel: "",
    region: "",
    regionLabel: "",
    district: "",
    districtLabel: "",
    council: "",
    councilLabel: "",
    officeAddr: "",
    postalAddr: "",
    objective: "",
    isAffiliated: isAffiliated.yes,
    affiliateInfo: "",
    isRestricted: isRestricted.yes,
    restrictionInfo: "",
    noOfMembers: "",
    formationDate: "",
    is337: isRegistered.no,
    name337: "",
    number337: "",
    purpose337: "",
    isInterestInLand: isInterested.yes,
    landDetails: "",
    officeBearTitle: "",
    holderNames: "",
    holdingTerms: "",
    chairmanName: "",
    chairmanSign: "",
    secretaryName: "",
    secretarySign: "",
    annexADoc: "",
    annexBDoc: "",
  };

  const setSubmitForm = () => {
    SubmitFormHandler(selectedItem);
  };

  const setPrevieForm = () => {
    setCompleteViewModel(false);
    setPreviewOpenModel(true);
  };

  const SubmitHandler = (values) => {
    //console.log(values);

    if (isSubmitable && isSubmit) {
      if (!values.assocName) {
        return toast.error(t("Association_Name"));
      } else if (!values.games || values.games.length == 0) {
        return toast.error("Please select Sports Discipline");
      } else if (!values.typeOfReg) {
        return toast.error("Please select Type of Association");
      } else if (!values.typeOfAssoc) {
        return toast.error("Please select Category of Association");
      } else if (!values.region) {
        return toast.error("Please select Region");
      } else if (!values.district || !district) {
        return toast.error("Please select District");
      } else if (!values.council || !council) {
        return toast.error("Please select Council");
      } else if (!values.officeAddr) {
        return toast.error("Please enter Office Address");
      } else if (!values.postalAddr) {
        return toast.error("Please enter Postal Address");
      } else if (!values.objective) {
        return toast.error("Please enter Objective");
      }
      // else if (isAffiliated.yes ) {
      //  return toast.error("Please select Is Affiliated");
      //  }
      // else if (!values.isAffiliated ) {
      //   return toast.error("Please select Is Affiliated");
      // }
      // else if (!values.affiliateInfo) {
      // return toast.error("Please select Affiliate Information");
      // }else if (!values.isRestricted) {
      // return toast.error("Please select Is Restricted");
      // }else if (!values.restrictionInfo) {
      // return toast.error("Please select Restriction Information");
      // }
      else if (!values.noOfMembers) {
        return toast.error("Please enter No Of Members");
      }
      //else if (!values.formationDate) {
      //   return toast.error("Please select Formation Date");
      // }
      //else if (!values.is337) {
      // return toast.error("Please select Is 337");
      // }else if (!values.name337) {
      // return toast.error("Please select Name 337");
      // }else if (!values.isInterestInLand) {
      //return toast.error("Please select Is Interest In Land");
      // }
      // else if (!values.landDetails) {
      //  return toast.error("Please select Land Details");
      // }
      else if (!values.officeBearTitle) {
        return toast.error("Please enter Office Bear Title");
      } else if (!values.holderNames) {
        return toast.error("Please enter Holder Names");
      } else if (!values.holdingTerms) {
        return toast.error("Please enter Holding Terms");
      } else if (!values.chairmanName) {
        return toast.error("Please enter Chairman Name");
      } else if (!chairmanSign) {
        return toast.error("Please upload Chairman Signature");
      } else if (!values.secretaryName) {
        return toast.error("Please enter Secretary Name");
      } else if (!secretarySign) {
        return toast.error("Please upload Secretary Signature");
      } else {
        setSelectedItem(values);
        setCompleteViewModel(true);
        //assocRegisterMutate(body);
      }
    }

    // else if (isPreview == true) {
    //   console.log("Preview data available");
    //   setSelectedItem(values);
    //   console.log("selectedItem", selectedItem);
    //   setOpenViewModel(true);

    // }
    else if (isSave == true) {
      if (!values.assocName) {
        return toast.error("Please enter Association Name");
      } else if (!values.games || values.games.length == 0) {
        return toast.error("Please select Sports Discipline");
      } else if (!values.typeOfReg) {
        return toast.error("Please select Type of Association");
      } else if (!values.typeOfAssoc) {
        return toast.error("Please select Category of Association");
      } else if (!values.region) {
        return toast.error("Please select Region");
      } else if (!values.district || !district) {
        return toast.error("Please select District");
      } else if (!values.council || !council) {
        return toast.error("Please select Council");
      } else {
        SaveFormHandler(values);
        //
      }
    } else {
      //setIsSubmitable(true);
    }
  };

  const SaveFormHandler = (values) => {
    const body = new FormData();
    //body.append("assoRegister", values);
    body.append("custId", user.id);
    body.append("email", user.email);
    body.append("assocName", values.assocName);
    body.append("typeOfAssoc", values.typeOfAssoc);
    body.append("typeOfReg", values.typeOfReg);
    body.append("region", values.region);
    body.append("district", values.district);
    body.append("council", values.council);
    body.append("typeOfAssocLabel", values.typeOfAssocLabel);
    body.append("typeOfRegLabel", values.typeOfRegLabel);
    body.append("regionLabel", values.regionLabel);
    body.append("districtLabel", values.districtLabel);
    body.append("councilLabel", values.councilLabel);
    body.append("officeAddr", values.officeAddr);
    body.append("postalAddr", values.postalAddr);
    body.append("objective", values.objective);
    if (isAffiliated.yes != false) body.append("isAffiliated", 1);
    else body.append("isAffiliated", 0);
    body.append("affiliateInfo", values.affiliateInfo);
    if (isRestricted.yes != false) body.append("isRestricted", 1);
    else body.append("isRestricted", 0);
    body.append("restrictionInfo", values.restrictionInfo);
    body.append("noOfMembers", values.noOfMembers);
    body.append("formationDate", values.formationDate);
    if (isRegistered.yes != false) {
      body.append("is337", 1);
      body.append("name337", values.name337);
      body.append("number337", values.number337);
    } else {
      body.append("is337", 0);
      body.append("name337", "NA");
      body.append("number337", "NA");
    }
    // if (!values.purpose337) {
    //   return toast.error("Please enter Association purpose");
    // }
    body.append("purpose337", "NA");
    if (isInterested.yes != false) body.append("isInterestInLand", 1);
    else body.append("isInterestInLand", 0);
    if (isInterested.yes != false) {
      if (!values.landDetails) {
        return toast.error("Please enter Land Details");
      }
    }
    body.append("landDetails", values.landDetails);
    body.append("officeBearTitle", values.officeBearTitle);
    body.append("holderNames", values.holderNames);
    body.append("holdingTerms", values.holdingTerms);
    body.append("chairmanName", values.chairmanName);
    body.append("secretaryName", values.secretaryName);
    body.append("secretarySignature", secretarySign);
    body.append("annexADoc", values.annexADoc);
    body.append("annexBDoc", values.annexBDoc);
    body.append("chairmanSignature", chairmanSign);
    body.append("game", values.game);
    if (values.games != "undefined" && values.games.length != 0) {
      const selectedGames = [];
      values.games.map((ele) => selectedGames.push(ele.value));
      body.append("games", selectedGames);
    } else {
      body.append("games", "");
    }
    body.append("gameLabel", values.gameLabel);
    setSelectedItem(values);
    assocRegisterMutateSave(body);
  };

  const SubmitFormHandler = (values) => {
    const body = new FormData();
    //body.append("assoRegister", values);
    body.append("custId", user.id);
    body.append("email", user.email);
    body.append("assocName", values.assocName);
    body.append("typeOfAssoc", values.typeOfAssoc);
    body.append("typeOfReg", values.typeOfReg);
    body.append("region", values.region);
    body.append("district", values.district);
    body.append("council", values.council);
    body.append("typeOfAssocLabel", values.typeOfAssocLabel);
    body.append("typeOfRegLabel", values.typeOfRegLabel);
    body.append("regionLabel", values.regionLabel);
    body.append("districtLabel", values.districtLabel);
    body.append("councilLabel", values.councilLabel);
    body.append("officeAddr", values.officeAddr);
    body.append("postalAddr", values.postalAddr);
    body.append("objective", values.objective);
    if (isAffiliated.yes != false) body.append("isAffiliated", 1);
    else body.append("isAffiliated", 0);
    body.append("affiliateInfo", values.affiliateInfo);
    if (isRestricted.yes != false) body.append("isRestricted", 1);
    else body.append("isRestricted", 0);
    body.append("restrictionInfo", values.restrictionInfo);
    body.append("noOfMembers", values.noOfMembers);
    body.append("formationDate", values.formationDate);
    if (isRegistered.yes != false) body.append("is337", 1);
    else body.append("is337", 0);
    body.append("name337", "NA");
    body.append("number337", "NA");
    // if (!values.purpose337) {
    //   return toast.error("Please enter Association purpose");
    // }
    body.append("purpose337", "NA");
    if (isInterested.yes != false) body.append("isInterestInLand", 1);
    else body.append("isInterestInLand", 0);
    if (isInterested.yes != false) {
      if (!values.landDetails) {
        return toast.error("Please enter Land Details");
      }
    }
    body.append("landDetails", values.landDetails);
    body.append("officeBearTitle", values.officeBearTitle);
    body.append("holderNames", values.holderNames);
    body.append("holdingTerms", values.holdingTerms);
    body.append("chairmanName", values.chairmanName);
    body.append("secretaryName", values.secretaryName);
    body.append("secretarySignature", secretarySign);
    body.append("annexADoc", values.annexADoc);
    body.append("annexBDoc", values.annexBDoc);
    body.append("chairmanSignature", chairmanSign);
    body.append("game", values.game);
    if (values.games != "undefined" && values.games.length != 0) {
      const selectedGames = [];
      values.games.map((ele) => selectedGames.push(ele.value));
      body.append("games", selectedGames);
    } else {
      body.append("games", "");
    }
    body.append("gameLabel", values.gameLabel);
    //setSelectedItem(values);
    assocRegisterMutate(body);
  };

  const SetDynamicAssociation = (value) => {
    //console.log(DistrictsList[value]);
    setAssociation(gTypeOfAssociations[value]);
    //console.log(districtsList);
  };

  //console.log(districtsList)
  const DistrictList = districtsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const CouncilList = councilList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <>
      <Navbar />
      {previewOpenModel && (
        <ViewModal
          setPreviewOpenModel={setPreviewOpenModel}
          selectedItem={selectedItem}
        />
      )}
      {completeViewModel && (
        <CompleteModal
          setPrevieForm={setPrevieForm}
          setSubmitForm={setSubmitForm}
          setCompleteViewModel={setCompleteViewModel}
          selectedItem={selectedItem}
        />
      )}
      {submitDocsModel && (
        <IsDocsModel
          setIsDocsModel={setSubmitDocsModel}
          selectedAppId={selectedAppId}
          appStatus={0}
        />
      )}
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t("App_Registration")}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t("national_sport")}</BoxSubTitle>
          <br></br>

          {/* <div class ="flex flex-row"> 
            {isSubmitable && (
                          <IoIosArrowBack
                            type="button"
                            onClick={() => setIsSubmitable(false)}  
                            onMouseOver={<>Previous</>}
                          > 
                            </IoIosArrowBack>
                          )} 
                          <span class="caret content-center	" >Previous.</span> 
            </div>
           */}
          {isSubmitable && (
            <IoIosArrowBack
              type="button"
              onClick={() => setIsSubmitable(false)}
              // onMouseOver={<>Previous</>}
            >
              <span class="caret">Previous.</span>
            </IoIosArrowBack>
          )}

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            //enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                    {!isSubmitable ? (
                      <>
                        {/* <CombineInputGroup> */}
                        <InputGroup>
                          <Label htmlFor="assocName">{t("a_name")}</Label>
                          <FieldWrapper>
                            <Field
                              name="assocName"
                              id="assocName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="game">{t("TypeOfGame")}</Label>
                          <FieldWrapper $select={true}>
                            <Field
                              required
                              name="games"
                              id="games"
                              autoComplete="off"
                            >
                              {(props) => (
                                <Select
                                  className="w-full h-full"
                                  isMulti
                                  options={GameList}
                                  defaultValue={games}
                                  onChange={(val) => {
                                    //console.log(val)
                                    setGameLabel(val.label);
                                    setGame(val.value);
                                    setGames(val);
                                    props.form.setFieldValue("games", val);
                                    props.form.setFieldValue("game", val.value);
                                    props.form.setFieldValue(
                                      "gameLabel",
                                      val.label
                                    );
                                  }}
                                />
                              )}
                            </Field>
                          </FieldWrapper>
                        </InputGroup>
                        {/* </CombineInputGroup> */}
                        <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="typeOfReg">
                              {t("t_registration")}
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="typeOfReg"
                                id="typeOfReg"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    required
                                    className="w-full h-full"
                                    options={RegistrationList}
                                    defaultValue={{
                                      label: typeOfRegLabel,
                                      value: typeOfReg,
                                    }}
                                    onChange={(val) => {
                                      setTypeOfRegLabel(val.label);
                                      setTypeOfReg(val.value);
                                      SetDynamicAssociation(val.value);
                                      props.form.setFieldValue(
                                        "typeOfReg",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "typeOfRegLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="typeOfAssoc">
                              {t("t_association")}
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="typeOfAssoc"
                                id="typeOfAssoc"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={AssociationList}
                                    defaultValue={{
                                      label: typeOfAssocLabel,
                                      value: typeOfAssoc,
                                    }}
                                    onChange={(val) => {
                                      setTypeOfAssocLabel(val.label);
                                      setTypeOfAssoc(val.value);
                                      props.form.setFieldValue(
                                        "typeOfAssoc",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "typeOfAssocLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                        </CombineInputGroup>
                        <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="region">{t("c_region")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="region"
                                id="region"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={RegionList}
                                    defaultValue={{
                                      label: regionLabel,
                                      value: region,
                                    }}
                                    onChange={(val) => {
                                      setRegionLabel(val.label);
                                      setRegion(val.value);
                                      SetDynamicDistricts(val.value);
                                      // formikProps.values.district="";
                                      props.form.setFieldValue(
                                        "region",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "regionLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="district">{t("C_District")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="district"
                                id="district"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={DistrictList}
                                    value={{
                                      label: districtLabel,
                                      value: district,
                                    }}
                                    onChange={(val) => {
                                      setDistrictLabel(val.label);
                                      setDistrict(val.value);
                                      SetDynamicCouncil(val.value);
                                      props.form.setFieldValue(
                                        "district",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "districtLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="council">{t("C_Council")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="council"
                                id="council"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    options={CouncilList}
                                    value={{
                                      label: councilLabel,
                                      value: council,
                                    }}
                                    onChange={(val) => {
                                      setCouncilLabel(val.label);
                                      setCouncil(val.value);
                                      props.form.setFieldValue(
                                        "council",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "councilLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                        </CombineInputGroup>

                        <InputGroup>
                          <Label htmlFor="officeAddr">
                            {t("Office_Address")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="officeAddr"
                              id="officeAddr"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="postalAddr">
                            {t("Postal_Address")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postalAddr"
                              id="postalAddr"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="objective">
                            {t("Objectives_Association")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="objective"
                              as="textarea"
                              rows="6"
                              id="objective"
                              placeholder={t("Type_here")}
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("association_branch")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isAffiliated.yes}
                              onChange={(value) => {
                                setIsAffiliated(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("Yes")}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              name="my-input"
                              checked={isAffiliated.no}
                              onChange={(value) => {
                                setIsAffiliated(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("No")}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>

                        {isAffiliated.yes && (
                          <InputGroup>
                            <Label htmlFor="affiliateInfo">
                              {" "}
                              {t("particulars_organization")}
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="affiliateInfo"
                                as="textarea"
                                rows="3"
                                id="affiliateInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )}

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("Is_membership")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              checked={isRestricted.yes}
                              onChange={(value) => {
                                setIsRestricted(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("Yes")}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              checked={isRestricted.no}
                              onChange={(value) => {
                                setIsRestricted(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("No")}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>

                        {isRestricted.yes && (
                          <InputGroup>
                            <Label htmlFor="restrictionInfo">
                              {" "}
                              {t("classes_of_persons")}
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="restrictionInfo"
                                as="textarea"
                                rows="3"
                                id="restrictionInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )}

                        <InputGroup>
                          <Label htmlFor="noOfMembers">
                            {t("Present_number")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="noOfMembers"
                              id="noOfMembers"
                              autoComplete="off"
                              type="number"
                            />
                          </FieldWrapper>
                        </InputGroup>
                      </>
                    ) : (
                      <>
                        {/* <InputGroup>
                          <Label htmlFor="formationDate">
                            {t("Association_formed")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="formationDate"
                              id="formationDate"
                              autoComplete="off"
                              type="date"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        {/* /abcd start */}
                        {/* <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("registered_under")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isRegistered.yes}
                              onChange={(value) => {
                                setIsRegistered(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"Yes"}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              name="my-input"
                              checked={isRegistered.no}
                              onChange={(value) => {
                                setIsRegistered(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"No"}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper> */}

                        {/* /* abcd end  */}

                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          name="my-input"
                          checked={isRegistered}
                          onChange={(value) => {
                            setIsRegistered(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label="Was it registered under societies Ordinance Cap. 337?"
                        /> */}

                        {
                          // isRegistered.yes && (
                          //   <InputGroup>
                          //     <Label htmlFor="name337">
                          //       {/* {" "}
                          //       Registration number */}
                          //       {t("r_name")}
                          //     </Label>
                          //     <FieldWrapper>
                          //       <Field
                          //         name="name337"
                          //         id="name337"
                          //         autoComplete="off"
                          //         type="text"
                          //       />
                          //     </FieldWrapper>
                          //     <Label htmlFor="number337">
                          //       {/* {" "}
                          //       Registration number */}
                          //       {/* {t("r_name")} */}
                          //       Registration Number
                          //     </Label>
                          //     <FieldWrapper>
                          //       <Field
                          //         name="number337"
                          //         id="number337"
                          //         autoComplete="off"
                          //         type="text"
                          //       />
                          //     </FieldWrapper>
                          //   </InputGroup>
                          // )
                        }

                        {/* {isRegistered && (
                          <>
                            <InputGroup>
                              <Label htmlFor="name337">{t("r_name")}</Label>
                              <FieldWrapper>
                                <Field
                                  name="name337"
                                  id="name337"
                                  autoComplete="off"
                                  type="text"
                                />
                              </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                              <Label htmlFor="number337">
                                Registration number
                              </Label>
                              <FieldWrapper>
                                <Field
                                  name="number337"
                                  id="number337"
                                  autoComplete="off"
                                  type="text"
                                />
                              </FieldWrapper>
                            </InputGroup>
                          </>
                        )} */}

                        {/* <InputGroup>
                          <Label htmlFor="postal">
                            In what District/Districts/Regions of Tanzania does
                            the Association carry on its activities?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postal"
                              id="postal"
                              autoComplete="off"
                              type="text"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        {/* <InputGroup>
                          <Label htmlFor="purpose337">
                            What Sport/Sports does the Association intend to
                            pursue?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="purpose337"
                              id="purpose337"
                              autoComplete="off"
                              type="text"
                              required
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("Association_Association_Land")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isInterested.yes}
                              onChange={(value) => {
                                setIsInterested(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("Yes")}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              name="my-input"
                              checked={isInterested.no}
                              onChange={(value) => {
                                setIsInterested(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={t("No")}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>

                        {isInterested.yes && (
                          <InputGroup>
                            <Label htmlFor="landDetails">
                              {/* {" "}
                              Registration number */}
                              {/* {t("r_name")} */}
                              {t("reference_to_registration")}
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="landDetails"
                                id="landDetails"
                                autoComplete="off"
                                as="textarea"
                                rows="3"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )}

                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          name="my-input"
                          checked={isInterested}
                          onChange={(value) => {
                            setIsInterested(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label="Does the Association have any interest in Land?"
                        /> */}

                        {/* {isInterested && (
                          <InputGroup>
                            <Label htmlFor="landDetails">
                              Give details of the land where possible by
                              reference to registration
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="landDetails"
                                as="textarea"
                                rows="3"
                                id="landDetails"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )} */}

                        <InputGroup>
                          <Label htmlFor="officeBearTitle">
                            {t("office_bearers")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="officeBearTitle"
                              id="officeBearTitle"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="holderNames">
                            {t("present_holders")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="holderNames"
                              id="holderNames"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="holdingTerms">{t("they_hold")}</Label>
                          <FieldWrapper>
                            <Field
                              name="holdingTerms"
                              id="holdingTerms"
                              as="textarea"
                              rows="3"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        {/* <InputGroup>
                          <Label htmlFor="rules">
                            Please upload constitution & rules of the
                            Association
                          </Label>
                          <DropZone setUploadFile={setUploadFile} />
                        </InputGroup> */}

                        <InputGroup>
                          <Label htmlFor="chairmanName">
                            {t("Chairman_Name")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="chairmanName"
                              id="chairmanName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="chairmanSign">
                            {t("Chairman_Signature")}
                          </Label>
                          <DropZone setUploadFile={setChairmanSignature} />
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="secretaryName">
                            {t("Secretary_Name")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="secretaryName"
                              id="secretaryName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="secretarySign">
                            {t("Secretary_Signature")}
                          </Label>
                          <DropZone setUploadFile={setSecretarySignature} />
                        </InputGroup>
                      </>
                    )}
                  </FormContainer>

                  <div className="mt-14">
                    {isSubmitable ? (
                      <div className="flex items-center space-x-10">
                        <PrevBtn
                          type="button"
                          onClick={() => setIsSubmitable(false)}
                        >
                          {t("Prev")}
                        </PrevBtn>
                        {/* <PreviewBtn
                          type="submit"
                          onClick={() => { setIsPreview(true); setIsSave(false); setIsSubmit(false); }}
                        >
                          Preview Form
                        </PreviewBtn> */}
                        <SaveBtn
                          type="submit"
                          // type="button"
                          onClick={() => {
                            setIsSave(true);
                            setIsPreview(false);
                            setIsSubmit(false);
                          }}
                        >
                          {t("Save")}
                        </SaveBtn>

                        <SubmitBtn
                          type="submit"
                          disabled={isLoading}
                          onClick={() => {
                            setIsSave(false);
                            setIsPreview(false);
                            setIsSubmit(true);
                          }}
                        >
                          {isLoading && (
                            <Loading
                              color="white"
                              width={20}
                              height={20}
                              noPadding={true}
                            />
                          )}
                          {!isLoading && t("Next_Step")}
                        </SubmitBtn>
                      </div>
                    ) : (
                      // :
                      // isSave ? (
                      //   <SubmitBtn onClick={() => setIsSave(true)}>
                      //   Save
                      // </SubmitBtn>
                      // )
                      <div className="flex items-center space-x-10">
                        {/* <SaveBtn type="submit"
                            // type="button"
                            onClick={() => { setIsSave(true); setIsPreview(false); setIsSubmit(false); }}
                          >
                            Save
                          </SaveBtn> */}
                        <SubmitBtn
                          type="submit"
                          onClick={() => setIsSubmitable(true)}
                        >
                          {t("Next")}
                        </SubmitBtn>
                      </div>
                    )}
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const LabelCheckboxWrapper = tw.div``;
const CheckboxWrapper = tw.div`flex items-center space-x-5 mt-2.5`;

export default RegistrationForm;
